import { BackendError } from '@/models/request';
import { isDate, isValid } from 'date-fns';
import { isFunction } from 'lodash';

export const isOfTypeBackendError = (
    toBeDetermined: object
): toBeDetermined is BackendError => {
    const error = toBeDetermined as BackendError;

    return (
        !!error.status &&
        error.status >= 400 &&
        !!error.timestamp &&
        !!error?.errors
    );
};

export const isOfTypeDate = (toBeDetermined: unknown): toBeDetermined is Date =>
    isDate(toBeDetermined) && isValid(toBeDetermined);

export const isOfTypeApiError = (
    toBeDetermined: Record<string, unknown>
): toBeDetermined is { error: unknown } => {
    return !!toBeDetermined?.error;
};

export const isOfTypeFunction = (
    toBeDetermined: unknown
): toBeDetermined is CallableFunction => {
    return isFunction(toBeDetermined);
};
